import { useEffect, useRef } from "react";
import useCurrentUser from "./use-current-user";

/**
 *
 * @param userData user data to update in local storage
 * @returns { enableProviderUpdate: Function}
 *
 * @description This hook is used to update the current provider in local storage
 *
 * @see enableProviderUpdate function is used to enable the setter
 *
 * @author [Rajkumar Rathod]
 */
export const useUpdateLocalStorageForCurrentProvider = (userData: any) => {
  const hasToUpdate = useRef<boolean>(false);
  const [_, setMe] = useCurrentUser();

  useEffect(() => {
    if (hasToUpdate.current) {
      setMe(userData);
      hasToUpdate.current = false;
    }
  }, [userData]);

  const enableProviderUpdate = () => {
    hasToUpdate.current = true;
  };

  return { enableProviderUpdate };
};
